import { matchRoutes, useLocation } from "react-router-dom";
import type { AddAccountMode } from "./types";

export const VERIFYROUTES = {
  verifyOptions: "verify-options",
  instantVerify: "instant-verify",
  manualVerify: "manual-verify",
  manualComplete: "manual-complete"
};

export const DASHBOARD_LINKED_ACCOUNTS_BASENAME = "dashboard/linked-accounts";

const DASHBOARD_LINKED_ACCOUNTS_DIALOG_ROUTES = [
  {
    path: `/${DASHBOARD_LINKED_ACCOUNTS_BASENAME}/${VERIFYROUTES.verifyOptions}`
  },
  {
    path: `/${DASHBOARD_LINKED_ACCOUNTS_BASENAME}/${VERIFYROUTES.instantVerify}`
  },
  {
    path: `/${DASHBOARD_LINKED_ACCOUNTS_BASENAME}/${VERIFYROUTES.manualVerify}`
  },
  {
    path: `/${DASHBOARD_LINKED_ACCOUNTS_BASENAME}/${VERIFYROUTES.manualComplete}`
  }
];

const SETTINGS_DIALOG_ROUTES = [
  { path: `/linked_accounts/${VERIFYROUTES.verifyOptions}` },
  { path: `/linked_accounts/${VERIFYROUTES.instantVerify}` },
  { path: `/linked_accounts/${VERIFYROUTES.manualVerify}` },
  { path: `/linked_accounts/${VERIFYROUTES.manualComplete}` }
];

const TRANSFER_DIALOG_ROUTES = [
  { path: `/funds/${VERIFYROUTES.verifyOptions}` },
  { path: `/funds/${VERIFYROUTES.instantVerify}` },
  { path: `/funds/${VERIFYROUTES.manualVerify}` },
  { path: `/funds/${VERIFYROUTES.manualComplete}` },
  { path: `/loans/${VERIFYROUTES.verifyOptions}` },
  { path: `/loans/${VERIFYROUTES.instantVerify}` },
  { path: `/loans/${VERIFYROUTES.manualVerify}` },
  { path: `/loans/${VERIFYROUTES.manualComplete}` }
];

function getDialogRoutes(basename: string) {
  if (basename === "linked_accounts") {
    return SETTINGS_DIALOG_ROUTES;
  }
  if (basename === DASHBOARD_LINKED_ACCOUNTS_BASENAME) {
    return DASHBOARD_LINKED_ACCOUNTS_DIALOG_ROUTES;
  }
  return TRANSFER_DIALOG_ROUTES;
}

export const useIsAddAccountsDialogOpen = (basename: string) => {
  const location = useLocation();
  const dialogRoutes = getDialogRoutes(basename);
  const matchedRoutes = matchRoutes(dialogRoutes, location?.pathname) || [];
  const isDialogOpen = matchedRoutes?.length > 0;

  return isDialogOpen;
};

export const useAddAccountsDialogTitle = (
  basename: string,
  addAccountMode: AddAccountMode = "default"
) => {
  const location = useLocation();

  if (addAccountMode === "revalidateInstantVerification") {
    return {
      title: "Reconnect your account",
      titleFluentId: "add-account-revalidate"
    };
  }

  if (addAccountMode === "upgradeInstantVerification") {
    return {
      title: "Upgrade your account connection",
      titleFluentId: "add-account-upgrade"
    };
  }

  switch (location?.pathname) {
    case `/${basename}/${VERIFYROUTES.manualComplete}`:
      return {
        title: "Adding in progress!",
        titleFluentId: "add-account-pending"
      };
    default:
      return {
        title: "Add a new bank account",
        titleFluentId: "add-account-bank"
      };
  }
};

export const getAddAccountsDialogType = () => {
  const location = useLocation();
  return location?.pathname.split("/").pop();
};
